const {App, react2angular} = require('../../../react-dist/nativeEsignComponent').reactLibrary;

// first array is basic prop injection, the second array is service injection
angular
    .module('jv.React.NativeEsign', [])
    .component('reactNativeEsign', react2angular(App, [
        'firstName',
        'lastName',
        'locale',
        'translations',
        'getConsent',
        'consentDialog',
        'onReject',
        'onConsent',
        'onSaveSignature',
        'documentViewer',
        'closeOfferLetter',
        'documentURL'
    ], ['$http']));